import { customAsyncThunk, createCustomAsyncThunk } from 'utils/createThunk';
import { billsAndPayment } from 'services/endpoints';

const getOutstandingBills = customAsyncThunk('billsAndPayments/outstandingBills', 'get', billsAndPayment.outstandingBills);

export {
    getOutstandingBills,
};
